// import config from "../config";

const ApiUrlServices = {
    REFRESH_TOKEN: "/auth/authentication/refresh_token",
    SIGN_UP: "/auth/authentication/signup",
    SIGN_IN: "/auth/authentication/signin",
    SIGN_OUT: "/auth/authentication/global-logout",
    SOCIAL_SIGN_IN: "/auth/authentication/social-signin",
    REGISTER_DEVICE: "/notifications/register-device",
    UNREGISTER_DEVICE: "/notifications/unregister-device",
    RESEND_CONFIRMATION_CODE: "/auth/authentication/resend-confirmation-code",
    FORGOT_PASSWORD: "/auth/authentication/forgot-password",
    SOCIAL_OAUTH_TOKEN_URL: "/oauth2/token",
    SET_NEW_PASSWORD: "/auth/authentication/set-password",
    GET_CONFIRMATION_CODE_VALIDITY: "/auth/authentication/get-confirmation-code-validity",
    CHANGE_PASSWORD: "/auth/authentication/change_password",
    VERIFY_USER_ATTRIBUTE: "/auth/authentication/verify_user_attribute",
    REGISTRATION_CONFIRM_SIGNUP: "/auth/authentication/confirm-signup",
    COURSE_SEARCH: "/course/courses/search-get-course",
    USER_DETAILS: "/auth/users/",
    REQUEST_MENTOR_APPROVAL: "/auth/authentication/request-mentor-approval",
    SET_PRIMARY_EMAIL: "/auth/authentication/add_primary_email",
    RESEND_VERIFICATION_EMAIL: "/auth/authentication/resend_verification_email",
    CATEGORY_LIST: "/category/cat-list?page=1&limit=100",
    UPDATE_USER_PROFILE: (userId) => `/auth/users/${userId}`,
    TRANSACTION_LIST: (userId, lepk = "", lesk = "", legsipk = "", legsisk = "", limit = "") =>
        `/payment/users/${userId}/transactions?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=${limit}`,
    CHANGE_SETTINGS: "/notifications/change-settings",
    GET_NOTIFICATION_SETTINGS: (userId) => `/notifications/get-settings/${userId}`,
    PROFILE_PIC_UPDATE: (userId) => `/auth/users/change_picture/${userId}`,
    SOCIALS_UPDATE_LINKS: (userId) => `/auth/users/${userId}/update_links`,
    GET_WISHLIST_BY_ID: (userId) => `/course/users/${userId}/favorite-courses`,
    REMOVE_COURSE_FROM_WISHLIST: (userId, courseId) => `/course/users/${userId}/favorite-courses/${courseId}`,
    ADD_COURSE_TO_WISHLIST: (userId) => `/course/users/${userId}/favorite-courses`,
    USER_GET_ALL_COURSE_ENROLLMENT: (userId, lepk = "", lesk = "", legsipk = "", legsisk = "", limit = "") =>
        `/course/users/${userId}/enrolled?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=${limit}`,
    GET_COURSES_BY_ID: `/course/courses/get-course-id-list`,
    SET_COURSE_START_FLAG: (userId, courseId) => `/course/users/${userId}/enrolled/${courseId}`,
    GET_CIRTIFICATE: (certificateId) => `/course/courses/get_certificate/${certificateId}`,
    GET_COURSE_DETAILS: (slug) => `/course/courses/${slug}`,
    GET_COURSE_DETAILS_PUBLIC: (slug) => `/course/courses/${slug}/public`,
    GET_USER_PROFILE: (userId) => `/auth/users/${userId}`,
    GET_USER_PROFILE_PUBLIC: (userId) => `/auth/users/${userId}/public`,
    GET_COURSE_REVIEWS_BY_ID: (courseId, reviewStatus, lepk = "", lesk = "", legsipk = "", legsisk = "", limit = "") =>
        `/course/courses/${courseId}/reviews/${reviewStatus}?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=${limit}`,
    GET_ALL_COURSE_CHAPTER: (courseId, lepk, lesk) =>
        `/course/courses/${courseId}/chapters/all?lepk=${lepk}&lesk=${lesk}`,
    GET_PERMISSION_VIDEO_PUBLIC: `/course/courses/get_permission_public`,
    SET_COMPLETED_LESSON: (userId, courseId) => `/course/users/${userId}/progress-completed/${courseId}`,

    GET_CART_ENROLL_WISHLIST_BY_ID: (userId) => `/course/users/${userId}/bought-favorite-cart-courses`,
    ADD_TO_CART: (userId) => `/course/users/${userId}/cart`,
    ADD_TO_CART_BATCH: (userId) => `/course/users/${userId}/batch_add_cart`,
    GET_PERMISSION_VIDEO: `/course/courses/get_permission`,
    GET_EXAM_BY_EXAM_ID: (examId) => `/exam/exam_details/${examId}`,
    EXAM_START_GET_QUIZ: `/exam/exam_start`,
    GET_COMPLETED_CHAPTERS: (userId, courseId) => `/course/users/${userId}/progress-completed/${courseId}/lessons`,
    GET_EXAM_RESULT_API: (userId, courseId) => `/exam/exam_list/user/${userId}/course/${courseId}`,
    EXAM_EVALUATION: `/exam/exam_evaluation`,
    REMOVE_FROM_CART: (userId, courseId) => `/course/users/${userId}/cart/${courseId}`,
    GET_CART_DATA: (userId, lepk, lesk) => `/course/users/${userId}/cart?lepk=${lepk}&lesk=${lesk}`,
    COUNT_CART_ITEM: (userId) => `/course/users/${userId}/cart-course-count`,
    APPLY_COUPON: "/payment/coupon/coupon_apply",
    REMOVE_COUPON: "/payment/coupon/coupon_remove_from_cart",
    DO_CHECKOUT: (userId) => `/payment/users/${userId}/checkout-cart`,
    STUDENT_LIST_COURSE: (courseId, lepk = "", lesk = "", legsipk = "", legsisk = "", limit = "") =>
        `/course/courses/${courseId}/students?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=${limit}`,
    GET_CERTIFICATE_LIST: (courseId, lepk = "", lesk = "", legsipk = "", legsisk = "", limit = "") =>
        `/course/courses/awaiting-certificates/${courseId}?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=${limit}`,
    ISSUE_CERTIFICATE: (userId, courseId) => `/course/users/${userId}/enrolled/${courseId}/issue_certificate`,
    // Create Course
    CREATE_COURSE: "/course/courses",
    COURSE_DETAILS: "/course/courses",
    UPDATE_COURSE: "/course/courses",
    tag_list: "/tag/tag-list?page=1&limit=100",
    //News api
    NEWS_LIST: `/news/news-list`,
    NEWS_DETAIlS: "/news/news-details",

    //Event api
    EVENT_LIST: `/event/event-list`,
    EVENT_SEARCH: `/event/event-search`,

    //Faq api
    SITE_FAQ: "/faq/site-faq-list",

    //Contact api
    CONTACT_US_SEND: `/notifications/contact_us_save`,

    // Course Rating api
    COURSE_RATING: (courseId) => `/course/courses/${courseId}/reviews`,

    // ALl SESSION LIST
    GET_ALL_SESSION_LIST: (status, page, limit) =>
        `/live-session/public/sessions?meeting_status=${status}&page=${page}&limit=${limit}`,
    GET_AUTHORIZED_SESSION_LIST: (status, page, limit, self) =>
        `/live-session/public?meeting_status=${status}&page=${page}&limit=${limit}&self=${self}`,
    GET_AUTHORIZED_UNPUBLISHED_SESSION_LIST: (status, page, limit) =>
        `/live-session/dashboard?client_status=${status}&page=${page}&limit=${limit}`,
    GET_AUTHORIZED_PRIVATE_SESSION_LIST: (status, page, limit) =>
        `/live-session/dashboard?client_status=${status}&page=${page}&limit=${limit}&archived=true`,
    GET_INVITED_SESSION_LIST: () => `/live-session/attended`,
    GET_DASH_PUBLIC_SESSION_DETAILS: (session_id) => `/live-session/public/sessions?session_id=${session_id}`,
    GET_DASH_PRIVATE_SESSION_DETAILS: (session_id) => `/live-session/dashboard?session_id=${session_id}`,

    // ALl ATTENDEE LIST
    GET_ATTENDEES_LIST: (session_id) => `/live-session/${session_id}/attendees`,

    // CHECK_PAYMENT: (transaction_id) => `/payment/check_payment/${transaction_id}`,
    // CATEGORY_LIST: '/category/cat-list?page=1&limit=100',
    // CREATE_COURSE: '/course/courses',
    // UPDATE_COURSE: '/course/courses',
    // ,
    // // coursewise student list
    //

    // GET_USER_PROFILE: (userId) => `/auth/users/${userId}`,
    // GET_USER_PROFILE_PUBLIC: (userId) => `/auth/users/${userId}/public`,
    //
    //
    //
    //

    //
    //
    //
    //
    // GET_ALL_CURRENCY: "/currency/currency-list",
    // ,
    // COURSE_ENROLLMENT: (courseId) => `/course/courses/${courseId}/enrollment`,
    //
    // COURSE_UPDATE: (courseId) => `/course/courses/${courseId}`,
    // GET_NOTIFICATION_SETTINGS: (userId) => `/notification/get-settings/${userId}`,
    // CREATE_COURSE_QA: (courseId) => `/course/courses/${courseId}/qas`,
    // UPDATE_COURSE_QA: (courseId, qaId) => `/course/courses/${courseId}/qas/${qaId}`,
    // CREATE_COURSE_NOTES: (courseId) => `/course/courses/${courseId}/notes`,
    // CREATE_COURSE_NOTE_COMMENT: (courseId, notesId) => `/course/courses/${courseId}/notes/${notesId}/comments`,
    CREATE_COURSE_CHAPTER: (courseId) => `/course/courses/${courseId}/chapters`,
    DELETE_COURSE_CHAPTER: (courseId, chapterId) => `/course/courses/${courseId}/chapters/${chapterId}`,
    ADD_COURSE_CHAPTER_LESSON: (courseId, chapter_id) => `/course/courses/${courseId}/chapters/${chapter_id}`,
    GET_PERMISSION_VIDEO_REQ: (courseId, chapter_id, idx, enrolled) =>
        `/course/courses/get_permission_gr?course_id=${courseId}&chapter_id=${chapter_id}&lesson_index=${idx}&check_enrolled=${enrolled}`,
    // GET_PERMISSION_VIDEO: `/course/courses/get_permission`,
    // GET_PERMISSION_VIDEO_PUBLIC: `/course/courses/get_permission_public`,
    GET_ALL_COURSE_QA: (courseId, lepk, lesk) => `/course/courses/${courseId}/qas/all?lepk=${lepk}&lesk=${lesk}`,
    GET_ALL_COURSE_NOTES: (courseId, lepk, lesk) => `/course/courses/${courseId}/notes/all?lepk=${lepk}&lesk=${lesk}`,
    // GET_ALL_COURSE_NOTE_COMMENT: (courseId, notesId, lepk = "", lesk = "") => `/course/courses/${courseId}/notes/${notesId}/comments/all?lepk=${lepk}&lesk=${lesk}`,
    //
    //
    // SET_PRIMARY_EMAIL: "/auth/authentication/add_primary_email",
    // RESEND_VERIFICATION_EMAIL: "/auth/authentication/resend_verification_email",
    // GET_COMPLETED_CHAPTERS: (userId, courseId) => `/course/users/${userId}/progress-completed/${courseId}/lessons`,
    // SET_COMPLETED_LESSON: (userId, courseId) => `/course/users/${userId}/progress-completed/${courseId}`,
    //
    //
    // ADD_COURSE_TO_WISHLIST: (userId) => `/course/users/${userId}/favorite-courses`,
    //

    // TRANSACTION_LIST: (userId, lepk = "", lesk = "", legsipk = "", legsisk = "") => `/payment/users/${userId}/transactions?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}`,
    // SALES_REPORT: (userId) => `/course/users/${userId}/sales-report`,
    // GET_COURSE_REVIEWS_BY_ID: (courseId, reviewStatus, lepk = "", lesk = "", legsipk = "", legsisk = "") => `/course/courses/${courseId}/reviews/${reviewStatus}?lepk=${lepk}&lesk=${lesk}&legsipk=${legsipk}&legsisk=${legsisk}&limit=6`,
    // NEWSLETTER_SUBSCRIPTION: `/notification/newsletter-subscription`,

    // //question

    // GET_QUESTIONS: (courseId, lessonId) => `/course/question/list/${courseId}/${lessonId}?limit=${30}`,
    // CREATE_QUESTION: `/course/question/create/`,
    // UPDATE_QUESTION: `/course/question/update/`,
    // DELETE_QUESTION: `/course/question/delete/`,

    // //exam setup
    // EXAM_SETUP_CREATE: (courseId) => `/course/update_course_exam_setup/${courseId}`,
    // GET_EXAM_SETUP: (courseId) => `/course/get_course_exam_setup/${courseId}`,
    // // quiz exam get
    // EXAM_START_GET_QUIZ: `/exam/exam_start`,
    // EXAM_EVALUATION: `/exam/exam_evaluation`,
    // GET_EXAM_RESULT_API: (userId, courseId) => `/exam/exam_list/user/${userId}/course/${courseId}`,
    // GET_EXAM_BY_EXAM_ID: (examId) => `/exam/exam_details/${examId}`,
    // GET_EXAM_BY_STATUS: (courseId, status, type) => `/exam/exam_list/course/${courseId}/exam_type/${type}/status/${status}`,

    // SCHEDULE_MEETING: `/chime-meeting/meetings`,
    //meeting get by status for a specific usr
    // SCHEDULE_MEETING_OF_SPECIFIC_USER: (userId, whoami, status) => `/chime-meeting/users/${userId}/meetings/${whoami}/${status}`,
    // SCHEDULE_LIST_BY_USER: (userId, whoAmI, status) => `/chime-meeting/users/${userId}/meetings/${whoAmI}/${status}`,
    // JOIN_MEETING: (meetingId) => `/chime-meeting/meetings/${meetingId}/join`,
    // MEETING_ATTENDEE_DETAILS: (meetingId, attendeeId) => `/chime-meeting/meetings/${meetingId}/attendees/${attendeeId}`,
    // RESCHEDULE_MEETING: (meetingId) => `/chime-meeting/meetings/${meetingId}/reschedule`,

    // END_MEETING: (meetingId) => `/chime-meeting/meetings/${meetingId}/end`,
    // ADD_CHANNEL: `/chime-meeting/chat-channels`,
    // LIST_CHANNEL: (userId, status, limit) => `/chime-meeting/users/${userId}/chat-channels/${status}?limit=${limit}`,
    // ACCEPT_REJECT_CHAT: (userId, channelName) => `/chime-meeting/users/${userId}/confirm-reject-channels/${channelName}`,
    // GET_CHANNEL_INFO: (channelName, userId) => `/chime-meeting/chat-channels/${channelName}?user_id=${userId}`,
    // GET_TOTAL_UNREAD_MSG: (userId) => `/chime-meeting/users/${userId}/chat-channels-total-message`,
    // MSG_READ_UNREAD: `/chime-meeting/read-unread-chat-message`,

    // GET_WRITTEN_EXAM_SUBMIT: `/exam/written_exam_submit`,
    // ISSUE_CERTIFICATE: (userId, courseId) => `/course/users/${userId}/enrolled/${courseId}/issue_certificate`,
    //
    //

    //Content Management
    // GET_PAGE_LIST: `/content-management/get-page-list`,

    // meeting APIs
    GET_MEETING_DETAILS: (meeting_id) => `/live-session/meeting/${meeting_id}`,

    // book apis
    GET_BOOK_LIST: "/product/get-public-products",
    GET_BOOK_DETAILS: (slug) => `/product/get-product-detail/${slug}`,
    GET_RELATED_BOOKS: (categoryId) => `/product/get-related-products/${categoryId}`,
    GET_BOOK_CATEGORY: "/product/get-categories",

    // book cart apis
    GET_BOOK_CART_DATA: (userId) => `/product/cart/get?user_id=${userId}`,
    ADD_TO_BOOK_CART: `/product/cart/add`,
    ADD_TO_BOOK_CART_BATCH: `/product/cart/batch-add`,
    UPDATE_CART_ITEM_QUANTITY: `/product/cart/update`,
    REMOVE_FROM_BOOK_CART: `/product/cart/remove`,
    COUNT_BOOK_CART_ITEM: (userId) => `/product/users/${userId}/cart-book-count`,
    CLEAR_BOOK_CART: (userId) => `/product/users/${userId}/cart/clear`,

    // New Checkout APIs
    BOOKS_CHECKOUT: "/product/order/checkout",

    // New Address Management APIs
    GET_USER_ADDRESSES: (userId) => `/product/address/${userId}`,
    ADD_USER_ADDRESS: "/product/address/add",
    UPDATE_USER_ADDRESS: '/product/address/update',
    DELETE_USER_ADDRESS: (userId, addressId) => `/users/${userId}/addresses/${addressId}`,
    SET_DEFAULT_ADDRESS: (userId, addressId) => `/users/${userId}/addresses/${addressId}/default`,

    // New Order APIs
    GET_ORDER_LIST: (id) => `/product/order/${id}`,
    GET_ORDER_DETAILS: (orderId) => `/product/order/detail/${orderId}`,

    FEEDBACK_LIST: `/news/news-list`,
    GALLERY_LIST : `/news/gallery-categories`
};

export default ApiUrlServices;
